import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
class PersonaIcon extends React.Component {
  render() {
    let draggableId = 'draggable-' + this.props.id;
    const index = parseInt(this.props.index);
    return (
      <Draggable draggableId={draggableId} index={index}>
        {(provided, snapshot) => (
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            className="icon-container slds-grid"
          >
            <div className="slds-grid slds-size_1-of-1 slds-grid_vertical-align-center">
              <div className="slds-grid slds-size_1-of-1 slds-grid_vertical-align-center">
                <div
                  className="draggable-persona"
                  style={{ backgroundImage: `url(${this.props.imgURL})` }}
                />
                <div
                  className="slds-m-left_xx-small slds-text_heading-small slds-truncate"
                  style={{ hyphens: 'auto' }}
                >
                  {this.props.name}
                </div>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    );
  }
}

PersonaIcon.propTypes = {
  name: PropTypes.string.isRequired,
  imgURL: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

export default PersonaIcon;
